module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external "@material/textfield/dist/mdc.textfield.js"
// module id = 8
// module chunks = 4 5